var _templateObject = _taggedTemplateLiteralLoose(['\n  color: #fff;\n  text-decoration: none;\n  font-family: ', ';\n  font-weight: 700;\n  font-size: 16px;\n  width: 100%;\n  flex-grow: 45;\n  position: relative;\n'], ['\n  color: #fff;\n  text-decoration: none;\n  font-family: ', ';\n  font-weight: 700;\n  font-size: 16px;\n  width: 100%;\n  flex-grow: 45;\n  position: relative;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { LinkBox, LinkFrame } from './shared';
import { Montserrat } from '../../assets/fonts';

var NavRoot = styled.span(_templateObject, Montserrat);
export default (function (_ref) {
  var option = _ref.option,
      comp = _ref.comp;
  var to = option.to,
      label = option.label,
      target = option.target,
      root = option.root,
      options = option.options;

  return React.createElement(
    'div',
    null,
    React.createElement(
      NavRoot,
      { key: to, target: target, className: (root && 'active') + ' pga-nav' },
      label
    ),
    React.createElement(
      'div',
      null,
      options.map(function (option) {
        var to = option.to,
            label = option.label,
            target = option.target,
            external = option.external;

        var CollapseComp = comp && !external ? comp : LinkFrame;
        return React.createElement(
          LinkBox,
          { key: label },
          React.createElement('i', { className: 'fa fa-angle-right m-2 text-white' }),
          React.createElement(
            CollapseComp,
            { exact: true, to: to, target: target, external: external, className: 'pga-nav' },
            option.label
          )
        );
      })
    )
  );
});